var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      class: [
        "selected-register-container",
        "lexon-view-container",
        { "everything-loaded": _vm.everythingLoaded },
      ],
    },
    [
      _c(
        "div",
        { class: ["header", { "alert-is-visible": _vm.alertIsVisibleGetter }] },
        [
          _c("AlertComponent", {
            attrs: {
              whereIsRendered: _vm.componentWhereIsRenderedAlertComponent,
            },
          }),
          _vm.showBreadcrumbs
            ? _c("LexonBreadcrumbsComponent", {
                attrs: { items: _vm.breadcrumbsItems },
              })
            : _vm._e(),
          _vm.showTitleHeader
            ? _c(
                "LfHeaderTitleComponent",
                {
                  attrs: {
                    title: _vm.breadcrumbsText,
                    buttons: _vm.buttons,
                    executeAction: _vm.executeAction,
                    showKebabMenu: _vm.showHeaderTitleKebabMenu,
                  },
                },
                [
                  _vm.isExpedientsDetailView &&
                  _vm.formLoaded &&
                  !_vm.isPortalUser
                    ? _c("StageSelectorComponent", {
                        attrs: { context: _vm.context },
                      })
                    : _vm._e(),
                  _vm.showIAButton && _vm.showHeaderTitleKebabMenu
                    ? _c("LfLabelButtonComponent", {
                        staticClass: "ia-search-button",
                        style: { minWidth: "140px" },
                        attrs: {
                          text: _vm.$t("views.search_ia.title"),
                          action: _vm.goToIASearch,
                          prependIconSrc: _vm.iaIcon,
                          variant: _vm.LabelButtonVariant.OUTLINED,
                          size: "md",
                        },
                      })
                    : _vm._e(),
                  _vm.showIAButton && _vm.showHeaderTitleKebabMenu
                    ? _c("div", {
                        staticClass: "ia-search-divider",
                        attrs: { "aria-hidden": "true" },
                      })
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _c("v-spacer"),
        ],
        1
      ),
      _vm.everythingLoaded
        ? _c("TabsComponent", {
            key: _vm.componentKey,
            ref: "tabsComponent",
            attrs: {
              tabs: _vm.getCurrentViewTabs(_vm.getContext),
              context: _vm.getContext,
              entity: _vm.entity(_vm.getContext),
              permissionsEntityProp: _vm.permissionsEntity
                ? _vm.permissionsEntity
                : null,
              beforeSetComponentProperties: _vm.onBeforeSetComponentProperties,
              beforeSetInitialTab: _vm.beforeSetInitialTab,
            },
            on: {
              "form-open": _vm.onOpenSubForm,
              "form-close": _vm.onCloseSubForm,
              "form-created": _vm.onCreatedForm,
              "form-mounted": _vm.onInitForm,
              "field-changed": _vm.onFieldChanged,
              "save-on-tab-change": _vm.save,
              "changed-tab": _vm.changeSelectedTabIndex,
              renderForm: _vm.onRenderForm,
              "change-breadcrumbs": _vm.changeBreadcrumbs,
              expedientGlobalVisionMounted: _vm.onExpedientGlobalVisionMounted,
              onBeforeSaveTabsVisibility: _vm.onBeforeSaveTabsVisibility,
              onAfterSaveTabsVisibility: _vm.onAfterSaveTabsVisibility,
            },
          })
        : _vm._e(),
      _c("TemplateSelectorComponent", {
        attrs: {
          showDialog: _vm.showTemplateDialog,
          idEntityType: _vm.entityType,
        },
        on: {
          closeTemplateDialog: _vm.closeTemplateDialog,
          generateTemplateDialog: _vm.generateTemplateDialog,
        },
      }),
      _vm.getShowFacturaEDialog
        ? _c("FacturaEDialog", {
            key: _vm.getFacturaEDialogKey,
            attrs: {
              showDialog: _vm.showFacturaEDialog,
              invoiceId: _vm.getSelectedInvoiceId,
              invoiceDescription: _vm.getSelectedInvoiceDescription,
              invoiceTemplates: _vm.hasProfessionalFacturaETemplate,
            },
            on: { closeDialog: _vm.closeFacturaEDialog },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }